import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Types
import type { ChartType } from '@/lib/analytics/charts/type';
// Lib
import { SIZE_FULL } from '@/lib/gridElements/size';
import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    TIKTOK_BUSINESS,
    YOUTUBE
} from '@/lib/socialProfile';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';
import { Trans } from '@/components/tools/translation';

export const followersGrowthConfig: ChartType<typeof LineChart> = {
    title: 'chart.group.follower_growth',
    margin: { left: -10, right: 25 },
    name: {
        date: 'date',
        value: 'chart.group.follower_growth_name'
    },
    id: 'followers_growth',
    color: {
        value: 'blue'
    },
    valueFormat: classicFormatMaxTwoDigits,
    tooltip: (
        <Trans
            i18nKey="analytics:chart.group.follower_growth_tooltip"
            components={{ br: <br /> }}
        />
    ),
    size: SIZE_FULL,
    type: 'chart',
    isXAxisDate: true,
    noDataToken: 'no_data_period',
    element: LineChart,
    hasComparativeView: true,
    aggregatedNetworks: [INSTAGRAM, FACEBOOK, LINKEDIN, TIKTOK_BUSINESS, YOUTUBE, PINTEREST]
};
